import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热门现场", href: "#hot" },
  { label: "分类频道", href: "#channel" },
  { label: "弹幕现场", href: "#live" },
  { label: "话题广场", href: "#topics" },
  { label: "玩法", href: "#play" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          {/* Logo */}
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span
              className={`w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center text-background-50 shadow-md ${
                scrolled ? "" : "ring-2 ring-background-50/60"
              }`}
            >
              <i className="ri-play-fill text-lg md:text-xl"></i>
            </span>
            <span
              className={`font-heading text-xl md:text-2xl tracking-wide ${
                scrolled ? "text-foreground-950" : "text-white"
              }`}
            >
              吃瓜视频网
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-white/90 hover:text-white hover:bg-white/10"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Search + actions */}
          <div className="flex items-center gap-2 md:gap-3">
            <div
              className={`hidden md:flex items-center gap-2 rounded-full px-3 py-2 transition-colors ${
                scrolled ? "bg-background-100 border border-background-200" : "bg-white/15 border border-white/25"
              }`}
            >
              <i className={`ri-search-line text-sm ${scrolled ? "text-foreground-400" : "text-white/80"}`}></i>
              <input
                type="text"
                placeholder="搜个瓜看看"
                className={`bg-transparent text-sm outline-none w-28 lg:w-36 placeholder:text-sm ${
                  scrolled ? "text-foreground-900 placeholder:text-foreground-400" : "text-white placeholder:text-white/70"
                }`}
              />
            </div>
            <a
              href="#live"
              className="hidden md:inline-flex items-center gap-1.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 whitespace-nowrap transition-colors"
            >
              <i className="ri-flashlight-fill"></i>
              去围观
            </a>
            {/* Mobile menu button */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                scrolled ? "bg-background-100 text-foreground-900" : "bg-white/15 text-white"
              }`}
              aria-label="打开菜单"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 pb-4 pt-2">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-lg"
              >
                {link.label}
              </a>
            ))}
            <div className="flex items-center gap-2 mt-2 px-3 py-2 bg-background-100 rounded-lg">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜个瓜看看"
                className="bg-transparent text-sm outline-none text-foreground-900 flex-1"
              />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}